export default "__VITE_ASSET__B13$XtKW__"